import React from 'react';
import type { FormInstance } from 'antd';
import { Form, InputNumber } from 'antd';
import MenuUnfoldOutlined from '@ant-design/icons/MenuUnfoldOutlined';
import MenuFoldOutlined from '@ant-design/icons/MenuFoldOutlined';
import { RibbonIconButton } from '../bookDefaultStyles/WordStyleRibbon';
import { styleFieldName } from '../../utils/styleFormFieldNames';
import { RibbonControlHint } from './RibbonControlHint';

const INDENT_STEP = 24;
const INDENT_LIMIT = 720;

type Props = {
  form: FormInstance;
  namePrefix?: string | string[];
  /** Hide the +/− indent icon buttons (keeps numeric input). */
  showButtons?: boolean;
};

export const ParagraphPositionControls: React.FC<Props> = ({ form, namePrefix, showButtons = true }) => {
  const indentField = styleFieldName(namePrefix, 'textIndent');
  const indent = Form.useWatch(indentField, form) ?? 0;

  const adjustIndent = (delta: number) => {
    const next = Math.max(-INDENT_LIMIT, Math.min(INDENT_LIMIT, Number(indent || 0) + delta));
    form.setFieldValue(indentField, next === 0 ? 0 : next);
  };

  return (
    <div className="word-ribbon-inline">
      {showButtons ? (
        <>
          <RibbonIconButton title="Decrease indent" onClick={() => adjustIndent(-INDENT_STEP)}>
            <MenuFoldOutlined />
          </RibbonIconButton>
          <RibbonIconButton title="Increase indent" onClick={() => adjustIndent(INDENT_STEP)}>
            <MenuUnfoldOutlined />
          </RibbonIconButton>
        </>
      ) : null}
      <RibbonControlHint title="Text indent (px) — positive indents, negative outdents">
        <Form.Item name={indentField} initialValue={0} noStyle>
          <InputNumber
            size="small"
            min={-INDENT_LIMIT}
            max={INDENT_LIMIT}
            step={INDENT_STEP}
            className="word-ribbon-compact-input"
            style={{ width: 56 }}
            placeholder="Ind"
          />
        </Form.Item>
      </RibbonControlHint>
    </div>
  );
};
